/**
 * Vendor program header block for image
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
    }

});

class VendorPartnerProgramImage extends Component {


    render() {
 
      const classes = this.props.classes;

      let imageAssets = [];
  
      let i = 0;
      for (i = 0; i < this.props.assets.length; i++) {
        let asset = this.props.assets[i];
        if (asset.assetType === 4) {
          imageAssets.push(asset);
        }
      }
  
      // Counter for unique keys
      let counter = 0;
      
      return (
        <Grid container spacing={2} justifyContent="center" alignItems="center">
  
          {imageAssets.length > 0 &&
  
  
          <React.Fragment>
            
            <Grid item>
              { imageAssets.map(link => {
                
                  return (
                  
                    <img height="200" width="250" alt={link.assetTitle} src={link.assetLink} />
                  )
              })}
                
            </Grid>
          </React.Fragment>}
        </Grid>
      );
    
    }

}
  
export default withStyles(styleSheet)(VendorPartnerProgramImage);